<template>
  <ErrorModal />
  <q-dialog v-model="show" persistent class="save-scheme-main">
    <q-card style="min-width: 350px" class="save-dialog">
      <q-card-section>
        <div style="color: #0a108f">Items opslaan</div>
      </q-card-section>

      <q-separator />

      <q-card-section class="q-pt-none q-pa-md">
        <div class="row justify-around">
          <q-select
            outlined
            bg-color="white"
            v-model="folderWithoutItems.folder"
            :options="folders"
            option-label="name"
            label="Selecteer een map"
            stack-label
            behavior="menu"
            style="width: 100%"
            dense
            :rules="[requiredSelectRule]"
            :disable="showInput == true"
          >
          </q-select>
        </div>
        <div class="row justify-around">
          <a v-if="folderWithoutItems.folder == null" @click="showInput = true">
            <i class="las la-1x la-plus"></i>
            Maak een nieuwe map
          </a>
          <q-input
            v-if="showInput && folderWithoutItems.folder == null"
            dense
            v-model="folderWithoutItems.newFolderName"
            outlined
            stack-label
            placeholder="Vul een mapnaam in"
            :rules="requiredFieldRule"
            style="width: 100%"
          />
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          color="white"
          class="save-btn-q"
          flat
          label="Opslaan"
          no-caps
          @click="saveSchemes()"
        />
        <q-btn
          flat
          class="cancel-btn"
          outline
          label="Annuleer"
          no-caps
          @click="disableSaveScheme()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref, reactive, onMounted } from 'vue';
import store from '../store/index';
import ErrorModal from './userProfile-components/ErrorModal.vue';
import UserService from '../services/userprofile.service';

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const showInput = ref(false);

    const folderWithoutItems = reactive({
      folder: null,
      newFolderName: '',
    });

    onMounted(() => {
      UserService.getFolders();
    });

    const folders = computed({
      get: () => store.state.user.folders,
    });

    const selectedResults = computed({
      get: () => store.state.grantItems.selectedResults,
    });

    const show = computed({
      get: () => store.state.user.showSaveScheme,
    });

    const disableSaveScheme = () => {
      store.commit('user/disableSaveScheme');
      showInput.value = false;
      folderWithoutItems.folder = null;
      folderWithoutItems.newFolderName = '';
    };

    const saveSchemes = async () => {
      await UserService.saveSchemes(
        folderWithoutItems,
        selectedResults.value
      );
      //   store.commit('grantItems/clearSelectedResults');

      showInput.value = false;
      folderWithoutItems.folder = null;
      folderWithoutItems.newFolderName = '';
    };

    return {
      show,
      folders,
      disableSaveScheme,
      saveSchemes,
      folderWithoutItems,
      showInput,
      selectedResults,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      requiredSelectRule(val) {
        if (val === null) {
          return 'Je moet een map selecteren!';
        }
      },
    };
  },
};
</script>
